import { Modal } from "react-bootstrap";
import { closeIcon } from "../../../../assets/svg";
import "./style.css";
import LineChart from "./LineChart";

interface mealPlanModal {
  open: boolean;
  setOpen: (target: boolean) => void;
  mealPlan: any;
}
const LineGraphModal = ({ open, setOpen, mealPlan }: mealPlanModal) => {
  const onClose = () => {
    setOpen(false);
    clear();
  };
  const data = [
    { x: 1, y: 10 },
    { x: 2, y: 12 },
    { x: 3, y: 34 },
    { x: 4, y: 53 },
    { x: 5, y: 98 },
    { x: 6, y: 48 },
    { x: 7, y: 18 },
    { x: 8, y: 9 },
  ];
  const clear = () => {};

  return (
    <Modal show={open} className="desktop-modal meal-modal">
      <Modal.Header>
        <Modal.Title className="heading">Graph</Modal.Title>
        <div onClick={onClose}>
          <img src={closeIcon} alt="close-icon" />
        </div>
      </Modal.Header>

      <Modal.Body>
        <div className="add-meal">
          <LineChart data={data} />
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default LineGraphModal;
